// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface UserDataResponseDto
 */
export interface UserDataResponseDto {
    /**
     *
     * @type {string}
     * @memberof UserDataResponseDto
     */
    subscriptionTier: UserDataResponseDtoSubscriptionTierEnum;
    /**
     *
     * @type {string}
     * @memberof UserDataResponseDto
     */
    username: string;
    /**
     *
     * @type {number}
     * @memberof UserDataResponseDto
     */
    creditsRemaining: number;
}

/**
 * @export
 */
export const UserDataResponseDtoSubscriptionTierEnum = {
    Trial: 'TRIAL',
    Pro: 'PRO',
} as const;
export type UserDataResponseDtoSubscriptionTierEnum =
    (typeof UserDataResponseDtoSubscriptionTierEnum)[keyof typeof UserDataResponseDtoSubscriptionTierEnum];

/**
 * Check if a given object implements the UserDataResponseDto interface.
 */
export function instanceOfUserDataResponseDto(value: object): value is UserDataResponseDto {
    if (!('subscriptionTier' in value) || value['subscriptionTier'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('creditsRemaining' in value) || value['creditsRemaining'] === undefined) return false;
    return true;
}

export function UserDataResponseDtoFromJSON(json: any): UserDataResponseDto {
    return UserDataResponseDtoFromJSONTyped(json, false);
}

export function UserDataResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserDataResponseDto {
    if (json == null) {
        return json;
    }
    return {
        subscriptionTier: json['subscriptionTier'],
        username: json['username'],
        creditsRemaining: json['creditsRemaining'],
    };
}

export function UserDataResponseDtoToJSON(value?: UserDataResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        subscriptionTier: value['subscriptionTier'],
        username: value['username'],
        creditsRemaining: value['creditsRemaining'],
    };
}
